/**
 * 高度自适应 textarea + 空值时按 Tab 自动补全 placeholder
 */

import { useEffect, useRef, type CSSProperties, type KeyboardEvent } from 'react'

interface Props {
  value: string
  placeholder?: string
  onChange: (value: string) => void
  style?: CSSProperties
  className?: string
  enableTabComplete?: boolean
  onFocus?: () => void
  onBlur?: () => void
  onUserKeyDown?: (e: KeyboardEvent<HTMLTextAreaElement>) => void
}

export function AutoGrowTextarea({
  value,
  placeholder,
  onChange,
  style,
  className,
  enableTabComplete = false,
  onFocus,
  onBlur,
  onUserKeyDown,
}: Props) {
  const ref = useRef<HTMLTextAreaElement>(null)

  useEffect(() => {
    const ta = ref.current
    if (!ta) return
    ta.style.height = 'auto'
    ta.style.height = `${ta.scrollHeight}px`
  }, [value])

  const handleKeyDown = (e: KeyboardEvent<HTMLTextAreaElement>) => {
    if (
      enableTabComplete &&
      e.key === 'Tab' &&
      !e.shiftKey &&
      value === '' &&
      placeholder
    ) {
      e.preventDefault()
      onChange(placeholder)
      return
    }
    onUserKeyDown?.(e)
  }

  return (
    <textarea
      ref={ref}
      value={value}
      placeholder={placeholder}
      rows={1}
      wrap="soft"
      onChange={(e) => onChange(e.target.value)}
      onKeyDown={handleKeyDown}
      onFocus={onFocus}
      onBlur={onBlur}
      className={className}
      style={{ resize: 'none', overflow: 'hidden', ...style }}
    />
  )
}
